import AssociatedContactsSelector from '@app/components/AssociatedContactsSelector'
import EditPageContainer from '@app/components/EditPageContainer'
import { FileDropzone, FileProgress } from '@app/components/FileUpload'
import Image from '@app/components/Image'
import { ImageSize } from '@app/models/enums'
import { ICurrentUserState } from '@app/store/modules/account'
import { bindFunctions } from '@app/utils/class'
import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { Input } from 'reactstrap'
import { actionCreators, IClientEditState } from '../modules/clientEdit'

interface IConnectionViewRouterProps {
  clientSlug: string
}

type IComponentProps = IClientEditState &
  ICurrentUserState &
  RouteComponentProps<IConnectionViewRouterProps> &
  typeof actionCreators

export default class ConnectionEditPage extends React.PureComponent<
  IComponentProps
> {
  constructor(props: IComponentProps) {
    super(props)

    bindFunctions(this)
  }

  public componentDidMount() {
    const { clientSlug } = this.props.match.params

    this.props.loadClient(clientSlug)
  }

  public componentWillUnmount() {
    this.props.resetState()
  }

  public render() {
    if (!this.props.client) {
      return <div />
    }

    return (
      <EditPageContainer
        saveDisabled={false}
        title={
          this.props.match.params.clientSlug
            ? this.props.client.name
            : 'New client'
        }
        onSaveClick={this._saveClient}
        onCancelClick={this._cancel}
      >
        <div className='container my-2'>
          {this._renderBasicInfo()}
          <h5 className='section-title'>Contacts</h5>
          {this._renderContacts()}
          <h5 className='section-title'>Photos</h5>
          {this._renderPhotos()}
          <h5 className='section-title'>Attachments</h5>
          {this._renderAttachments()}
        </div>
      </EditPageContainer>
    )
  }

  private _saveClient() {
    this.props.save(this.props.client.id)
  }

  private _cancel() {
    this.props.history.goBack()
  }

  private _renderBasicInfo() {
    return (
      <div className='d-flex flex-row align-items-center'>
        {this._renderProfileImage()}
        <Input
          className='ml-2'
          placeholder='Name'
          onChange={(e) => this.props.setName(e.target.value)}
          value={this.props.client.name}
        />
      </div>
    )
  }

  private _renderProfileImage() {
    const selectPhotoStyle: React.CSSProperties = {
      borderWidth: '0px',
    }

    return (
      <FileDropzone
        style={selectPhotoStyle}
        identifier='client-profile-image-editor'
      >
        <Image
          image={this.props.client.logo}
          style={{ cursor: 'pointer' }}
          size={ImageSize.h50w50}
          width={50}
          height={50}
        />
      </FileDropzone>
    )
  }

  private _renderPhotos() {
    const dropzoneStyle: React.CSSProperties = {
      borderColor: 'rgb(102, 102, 102)',
      borderRadius: '5px',
      borderStyle: 'dashed',
      borderWidth: '1px',
      display: 'table',
      height: '100px',
      width: '100%',
    }

    const dropzoneActiveStyle: React.CSSProperties = {
      borderColor: '#9aa41a',
      borderWidth: '2px',
    }

    return (
      <div>
        <FileDropzone
          style={dropzoneStyle}
          identifier='development-client-photos'
          activeStyle={dropzoneActiveStyle}
        >
          <p
            style={{
              display: 'table-cell',
              textAlign: 'center',
              verticalAlign: 'middle',
            }}
          >
            Drag and drop or click here to select files
          </p>
        </FileDropzone>
        <FileProgress
          identifier='development-client-photos'
          dataSource={this.props.client.photos}
        />
      </div>
    )
  }

  private _renderAttachments() {
    const dropzoneStyle: React.CSSProperties = {
      borderColor: 'rgb(102, 102, 102)',
      borderRadius: '5px',
      borderStyle: 'dashed',
      borderWidth: '1px',
      display: 'table',
      height: '100px',
      width: '100%',
    }

    const dropzoneActiveStyle: React.CSSProperties = {
      borderColor: '#9aa41a',
      borderWidth: '2px',
    }

    return (
      <div>
        <FileDropzone
          style={dropzoneStyle}
          identifier='development-client-attachments'
          activeStyle={dropzoneActiveStyle}
        >
          <p
            style={{
              display: 'table-cell',
              textAlign: 'center',
              verticalAlign: 'middle',
            }}
          >
            Drag and drop or click here to select files
          </p>
        </FileDropzone>
        <FileProgress
          identifier='development-client-attachments'
          dataSource={this.props.client.attachments}
        />
      </div>
    )
  }

  private _renderContacts() {
    return (
      <div className='ml-3'>
        <AssociatedContactsSelector
          value={this.props.client.contacts}
          onChange={this.props.setContacts}
          placeholder='Add contacts...'
        />
      </div>
    )
  }
}
